import {match} from 'ts-pattern';

import {isNotNil} from 'ramda';

import {FinancingFieldResponseBody} from '@dms/api/core';
import {FinancingCompositionLayer} from '@dms/api/shared';
import i18n from '@dms/i18n';

const LAYER_NAME_MAX_LENGTH = 24;
// Same token syntax the BE substitutes when it renders a financing promo photo.
const FIELD_TOKEN_PATTERN = /\{\{([A-Z0-9_]+)\}\}/g;

const getTokenName = (key: string, fields: FinancingFieldResponseBody[]) => {
  const field = fields.find((candidate) => candidate.key === key);
  const name = [field?.label, field?.sample].find(
    (value) => isNotNil(value) && value.trim().length > 0
  );
  return name ?? key;
};

/**
 * The name the editor shows for a layer: the start of its text, or its layer type. A `{{KEY}}`
 * token shows as its field label, so the name does not end in a cut raw token.
 */
export const getLayerName = (
  layer: FinancingCompositionLayer,
  fields: FinancingFieldResponseBody[]
) =>
  match(layer)
    .with({type: 'text'}, (textLayer) => {
      const text = textLayer.text
        .replace(FIELD_TOKEN_PATTERN, (_token, key: string) => getTokenName(key, fields))
        .trim();
      return text.length > 0
        ? text.slice(0, LAYER_NAME_MAX_LENGTH)
        : i18n.t('entity.watermark.composition.labels.textLayer');
    })
    .with({type: 'image'}, () => i18n.t('entity.watermark.composition.labels.imageLayer'))
    .with({type: 'rect'}, () => i18n.t('entity.watermark.composition.labels.rectLayer'))
    .with({type: 'photo'}, () => i18n.t('entity.promoPhotos.composition.labels.vehiclePhoto'))
    .exhaustive();
